import { ConditionOperatorEnumType } from '@reach/shared-types/conditions';
import type { ConditionOperator } from '@reach/shared-types/conditions';
import type { BuilderFieldType } from './segment-builder.types';

const { EQUALS, NOT_EQUALS, GREATER_THAN, LESS_THAN, EXISTS, NOT_EXISTS } = ConditionOperatorEnumType;
const { EQUALS_MONTH_DAY, EQUALS_MONTH_DAY_YEAR, BETWEEN_MONTH_DAY, BETWEEN_MONTH_DAY_YEAR } =
  ConditionOperatorEnumType;
const { ARRAY_CONTAINS, CONTAINS, NOT_CONTAINS, IN } = ConditionOperatorEnumType;

/**
 * Operators allowed per field type for the visual segment builder.
 * Used to filter the operator dropdown by selected field type.
 */
export const OPERATORS_BY_FIELD_TYPE: Record<BuilderFieldType, ConditionOperator[]> = {
  string: [EQUALS, NOT_EQUALS, CONTAINS, NOT_CONTAINS, IN, EXISTS, NOT_EXISTS],
  number: [EQUALS, NOT_EQUALS, GREATER_THAN, LESS_THAN, EXISTS, NOT_EXISTS],
  boolean: [EQUALS, NOT_EQUALS, EXISTS, NOT_EXISTS],
  date: [
    NOT_EQUALS,
    GREATER_THAN,
    LESS_THAN,
    EQUALS_MONTH_DAY,
    BETWEEN_MONTH_DAY,
    BETWEEN_MONTH_DAY_YEAR,
    EXISTS,
    NOT_EXISTS,
  ],
  array: [ARRAY_CONTAINS],
  unknown: [
    EQUALS,
    NOT_EQUALS,
    EXISTS,
    NOT_EXISTS,
    CONTAINS,
    NOT_CONTAINS,
    IN,
    GREATER_THAN,
    LESS_THAN,
    EQUALS_MONTH_DAY,
    EQUALS_MONTH_DAY_YEAR,
    BETWEEN_MONTH_DAY,
    BETWEEN_MONTH_DAY_YEAR,
    ARRAY_CONTAINS,
  ],
};

export function getOperatorsForFieldType(fieldType: BuilderFieldType): ConditionOperator[] {
  return OPERATORS_BY_FIELD_TYPE[fieldType] ?? OPERATORS_BY_FIELD_TYPE.unknown;
}
